import { render, staticRenderFns } from "./AboutSecond.vue?vue&type=template&id=1ab2fb50"
import script from "./AboutSecond.vue?vue&type=script&lang=js"
export * from "./AboutSecond.vue?vue&type=script&lang=js"
import style0 from "./AboutSecond.vue?vue&type=style&index=0&id=1ab2fb50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports